/**
 *
 * @param fn - returns promise, which give either some data or null
 * @param delay - polling delay in ms
 */
export const pollUntil = function (fn, delay) {
    let notCanceled = true;

    function pollRecursive() {
        return Promise.resolve().then(fn).then((noData) => (
            notCanceled && noData && new Promise((res) => (setTimeout(res, delay)))
                .then(pollRecursive)
        ));
    }

    let p = pollRecursive();
    p.cancel = () => (
        notCanceled = false
    );

    return p;
};

const withTimeout = (startTime, timeOut, fn) => {
    if (new Date().getTime() - timeOut > startTime) {
        console.log("Throwing with timeout")
        throw new Error("Timeout")
    }
    return fn();
}

/**
 *
 * @param fn - must return promise with truthful result to continue the poll
 * @param delay - delay between fn calls
 * @param timeOut - timeout befor thow with an error
 */
export const pollWTimeoutUntil = (fn, delay, timeOut = 3000) => {
    const startTime = new Date().getTime();
    pollUntil(withTimeout(startTime, timeOut, fn), delay)
}

